<template>
  <svg
    width="45px"
    height="54px"
    viewBox="0 0 45 54"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <slot />
    <title>SafeHarbor Logo</title>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="0128_003" transform="translate(-215.000000, -207.000000)">
        <g id="Modal">
          <g id="Group-7" transform="translate(182.000000, 159.000000)">
            <g id="SafeHarbor-Logo" transform="translate(36.000000, 51.000000)">
              <g>
                <path
                  d="M30,4.23529412 C25.5386087,4.23529412 22.101,3.04695652 19.5,0 C19.5,0 13.4569565,4.23529412 9,4.23529412 C5.0996087,4.23529412 3,2.82352941 -2.08008429e-13,0 L0,31.0588235 C0,31.0588235 0.543521739,42.9975652 19.5,48 C38.460913,42.9975652 39,31.0588235 39,31.0588235 L39,0 C36,2.82352941 30,4.23529412 30,4.23529412 Z"
                  id="Stroke-4819"
                  :stroke="color"
                  stroke-width="5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <circle id="Oval-Copy-11" :fill="color" cx="24" cy="21" r="6"></circle>
                <circle id="Oval-Copy-16" :fill="color" cx="12" cy="15" r="3"></circle>
                <circle id="Oval-Copy-17" :fill="color" cx="12" cy="27" r="3"></circle>
                <circle id="Oval-Copy-18" :fill="color" cx="24" cy="33" r="3"></circle>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
